{
  "hero.title": "多 CLI 環境切換器",
  "hero.tagline-1": "進入禪意般的心流程式設計狀態。",
  "hero.tagline-2": "無縫環境切換。",
  "hero.subtitle": "統一管理 Claude Code、Codex、OpenCode 設定，帶 API 代理自動故障轉移",
  "hero.getDocs": "查看文件",
  "features.title": "功能特性",
  "features.multiCli.title": "多 CLI 支援",
  "features.multiCli.desc": "支援 Claude Code、Codex、OpenCode，可按專案設定",
  "features.multiConfig.title": "多設定管理",
  "features.multiConfig.desc": "在統一的 JSON 檔案中管理所有 API provider 設定",
  "features.daemon.title": "統一守護程序",
  "features.daemon.desc": "單一 zend 程序同時託管代理伺服器與 Web 管理介面",
  "features.failover.title": "代理故障轉移",
  "features.failover.desc": "內建 HTTP 代理，主 provider 不可用時自動切換備用",
  "features.routing.title": "場景路由",
  "features.routing.desc": "根據請求特徵（thinking、image 等）智慧路由到不同 provider",
  "features.binding.title": "專案綁定",
  "features.binding.desc": "將目錄綁定到特定 profile 和 CLI，實現專案級自動設定",
  "features.envVars.title": "環境變數",
  "features.envVars.desc": "在 provider 級別為每個 CLI 單獨設定環境變數",
  "features.webUi.title": "Web 介面",
  "features.webUi.desc": "瀏覽器視覺化管理，支援密碼保護存取",
  "features.webSecurity.title": "Web 安全",
  "features.webSecurity.desc": "自動產生存取密碼、工作階段認證、RSA 加密令牌傳輸",
  "features.configSync.title": "組態同步",
  "features.configSync.desc": "透過 WebDAV/S3/GitHub 跨裝置同步組態，使用 AES-256-GCM 加密",
  "features.comingSoon": "更多功能，敬請期待",
  "install.title": "快速開始",
  "install.step1.title": "安裝 GoZen",
  "install.step1.desc": "一鍵安裝腳本",
  "install.step2.title": "設定 Provider",
  "install.step2.desc": "新增第一個 API provider",
  "install.step3.title": "啟動",
  "install.step3.desc": "使用預設設定啟動 CLI",
  "commands.title": "命令一覽",
  "commands.command": "命令",
  "commands.description": "說明",
  "commands.items.start": "啟動 CLI（使用專案綁定或預設設定）",
  "commands.items.profile": "使用指定 profile 啟動",
  "commands.items.profilePick": "互動選擇 profile",
  "commands.items.cli": "使用指定 CLI（claude/codex/opencode）",
  "commands.items.yes": "自動批准 CLI 權限（claude --permission-mode acceptEdits, codex -a never）",
  "commands.items.use": "直接使用指定 provider（無代理）",
  "commands.items.pick": "互動選擇 provider 啟動",
  "commands.items.list": "列出所有 provider 和 profile",
  "commands.items.configAddProvider": "新增 provider",
  "commands.items.configAddProfile": "新增 profile",
  "commands.items.configDefaultClient": "設定預設 CLI 用戶端",
  "commands.items.configDefaultProfile": "設定預設 profile",
  "commands.items.configResetPassword": "重設 Web UI 存取密碼",
  "commands.items.configSync": "從遠端同步後端拉取組態",
  "commands.items.daemonStart": "啟動 zend 守護程序",
  "commands.items.daemonStop": "停止守護程序",
  "commands.items.daemonStatus": "檢視守護程序狀態",
  "commands.items.daemonEnable": "安裝為系統服務",
  "commands.items.daemonDisable": "解除安裝系統服務",
  "commands.items.bind": "綁定目前目錄到 profile",
  "commands.items.bindCli": "綁定目前目錄使用指定 CLI",
  "commands.items.unbind": "解除目前目錄綁定",
  "commands.items.status": "顯示目前目錄綁定狀態",
  "commands.items.web": "在瀏覽器中開啟 Web 管理介面（自動啟動守護程序）",
  "commands.items.upgrade": "升級到最新版本",
  "commands.items.version": "顯示版本",
  "commands.items.completion": "產生 Shell 補全腳本（zsh/bash/fish）",
  "homepage.title": "多 CLI 環境切換器"
}
